
export default {
  props: {
    block: {
      type: String,
      default: 'center',
      validator: value => ['center', 'start', 'end', 'stretch', 'space-between', 'space-around'].includes(value)
    },

    inline: {
      type: String,
      default: 'center',
      validator: value => ['center', 'start', 'end', 'stretch', 'space-between', 'space-around'].includes(value)
    },

    direction: {
      type: String,
      default: 'row',
      validator: value => ['row', 'column', 'row-reverse', 'column-reverse'].includes(value)
    },

    gap: {
      type: [Number, String],
      default: undefined
    },

    noWrap: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    gapValue () {
      if (this.gap && (typeof this.gap === 'number' || !Number.isNaN(Number(this.gap)))) { return this.gap + 'rem'; }

      return this.gap;
    },

    classes () {
      const result = [];

      if (this.block !== 'center') { result.push(`block-${this.block}`); }

      if (this.inline !== 'center') { result.push(`inline-${this.inline}`); }

      if (this.direction !== 'row') { result.push(this.direction); }

      if (this.noWrap) { result.push('no-wrap'); }

      return result;
    }
  }
};
